import { c as _c } from "react/compiler-runtime";
import { Button, CircularProgress, type SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ButtonProps } from './ButtonProps';
import { defaultButtonStyles } from './defaultButtonStyles';
export function PrimaryButton(t0) {
  const $ = _c(7);
  let loading;
  let props;
  if ($[0] !== t0) {
    ({
      loading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = loading;
    $[2] = props;
  } else {
    loading = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      disabled: true,
      endIcon: <CircularProgress color="inherit" size={24} />
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const loadingProps = t1;
  const t2 = loading && loadingProps;
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <PrimaryButtonStyled variant="contained" {...props} color="primary" {...t2}>{props.text}</PrimaryButtonStyled>;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
const PrimaryButtonStyled = styled(Button, {})(({
  theme
}) => ({
  ...defaultButtonStyles,
  ...({
    border: 0,
    '&:active': {
      backgroundColor: theme.palette.action.active
    },
    '&:focus': {
      border: `1px solid ${theme.palette.action.focus}`
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled
    }
  } as SxProps)
}));